import React from "react"
import { Col, Row } from "react-bootstrap"

import "./article.scss"

const OnlyImageArticle = ({ image, isBlog }) => {
  return (
    <section className={"image image-article"}>
      <div className={isBlog ? " " : "container"}>
        <Row className="align-items-center">
          <Col lg="12" className="p-0">
            <img src={image} alt="wdn-profile-screenshot" />
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default OnlyImageArticle
